import * as React from "react";
import { FC } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface IProps {
    className?: string;
    style?: any;
}

export const Image360Icon: FC<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 36 36" {...props}>
            <g fill="none" fillRule="evenodd">
                <g>
                    <path d="M0 0H24V24H0z" transform="translate(6 6)" />
                    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                        <path
                            d="M9 4L11 6 9 8M14.02 5.847C18.627 5.37 22 3.828 22 2c0-.601-.378-1.168-1.033-1.679"
                            transform="translate(6 6) translate(1 13)"
                        />
                        <path
                            d="M1.033.321C.378.832 0 1.399 0 2c0 2.209 4.925 4 11 4L9 4"
                            transform="translate(6 6) translate(1 13)"
                        />
                    </g>
                    <text
                        fill="currentColor"
                        fontFamily="Lato-Heavy, Lato"
                        fontSize="10"
                        fontWeight="600"
                        transform="translate(6 6)"
                    >
                        <tspan x="3" y="14">
                            360
                        </tspan>
                    </text>
                </g>
            </g>
        </SvgIcon>
    );
};

export default Image360Icon;
